
            window.versions = {
                script: 33,
                atlas: {
                    preloader: 1,
                    core: 2,
                    "core-ui": 2,
                    lobby: 2,
                    competition: 3
                },
                layout: 8,
                sound: 2,
                font: 1,
                ambience: 1,
                descriptor: 8,
                image: 3
            };

            import(/* @vite-ignore */__ENTRY_FILE__);
        